import { coreGet, coreMutate } from "../../core-api/api-client";

export interface CustomCaseMetric {
  key: string;
  name: string;
  shortName?: string;
  enabled: boolean;
}
export interface CaseMetricConfiguration {
  version: number;
  automatic: { key: string; name: string }[];
  items: CustomCaseMetric[];
}
export const loadCaseMetricConfiguration = (signal?: AbortSignal) =>
  coreGet<CaseMetricConfiguration>("/basic-configuration/case-metrics", signal);
export const updateCaseMetricConfiguration = (
  expectedVersion: number,
  items: CustomCaseMetric[],
) =>
  coreMutate<CaseMetricConfiguration>(
    "/basic-configuration/case-metrics",
    "PUT",
    { expectedVersion, items },
  );

export interface OutboundSendConfiguration {
  defaultBccEmail: string;
  updatedAt: string;
}

export const loadOutboundSendConfiguration = (signal?: AbortSignal) =>
  coreGet<OutboundSendConfiguration>(
    "/basic-configuration/outbound-send",
    signal,
  );

export const updateOutboundSendConfiguration = (defaultBccEmail: string) =>
  coreMutate<OutboundSendConfiguration>(
    "/basic-configuration/outbound-send",
    "PUT",
    { defaultBccEmail },
  );
